const toNumberOrNull = (value) => {
  const parsed = Number.parseInt(value, 10)
  return Number.isNaN(parsed) ? null : parsed
}

export const canDisableCFF = ({
  clients = [],
  farms = [],
  selectedClientId,
  selectedFarmId,
}) => {
  if (clients.length !== 1 || farms.length !== 1) {
    return false
  }

  const normalizedClientId = toNumberOrNull(selectedClientId)
  const normalizedFarmId = toNumberOrNull(selectedFarmId)

  if (normalizedClientId === null || normalizedFarmId === null) {
    return false
  }

  const hasValidSelectedClient = clients.some(
    (client) => client.id === normalizedClientId,
  )

  const hasValidSelectedFarm = farms.some(
    (farm) => farm.id === normalizedFarmId,
  )

  return hasValidSelectedClient && hasValidSelectedFarm
}
